import { type CAPITAL_PARTNER_NETWORK_CONTENT } from '../content';
import {
  ContentContainer,
  ProofCard,
  ProofStrip,
  Section,
  SectionEyebrow,
  SectionIntro,
  SectionLead,
  SectionTitle,
  SurfaceText,
} from '../styles';

type WhyNowCopy = (typeof CAPITAL_PARTNER_NETWORK_CONTENT)['whyNow'];

type WhyNowSectionProps = {
  copy: WhyNowCopy;
};

export default function WhyNowSection({ copy }: WhyNowSectionProps) {
  return (
    <Section>
      <ContentContainer>
        <SectionIntro $wide>
          <SectionEyebrow>{copy.eyebrow}</SectionEyebrow>
          <SectionTitle>{copy.title}</SectionTitle>
          <SectionLead>{copy.body}</SectionLead>
        </SectionIntro>
        <ProofStrip>
          {copy.proofStrip.map((item) => (
            <ProofCard key={item}>
              <SurfaceText>{item}</SurfaceText>
            </ProofCard>
          ))}
        </ProofStrip>
      </ContentContainer>
    </Section>
  );
}
